export const VGS_DOWNLOAD_FRAME_LIFETIME_MS = 10 * 60_000;

interface PostVgsDownloadFormParams {
    url: string;
    fields: Readonly<Record<string, string>>;
    onFailure: () => void;
}

/**
 * Posts a form into a hidden iframe, so the browser saves the response VGS
 * rewrote as a download and our JavaScript can never read it. An attachment
 * does not load a document in the frame; an error page from the proxy does.
 */
export function postVgsDownloadForm({
    url,
    fields,
    onFailure,
}: PostVgsDownloadFormParams): void {
    const frame = document.createElement("iframe");
    frame.name = `vgs-download-${crypto.randomUUID()}`;
    frame.hidden = true;

    const form = document.createElement("form");
    form.method = "POST";
    form.action = url;
    form.target = frame.name;
    form.hidden = true;
    for (const [name, value] of Object.entries(fields)) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        form.append(input);
    }

    const removeFrame = () => frame.remove();
    frame.addEventListener("load", () => {
        if (isSameOriginDocument(frame)) {
            return;
        }
        removeFrame();
        onFailure();
    });

    document.body.append(frame, form);
    form.submit();
    form.remove();
    window.setTimeout(removeFrame, VGS_DOWNLOAD_FRAME_LIFETIME_MS);
}

/** The frame's initial `about:blank` is same-origin; a proxy response is not. */
function isSameOriginDocument(frame: HTMLIFrameElement): boolean {
    try {
        return frame.contentWindow?.location.href !== undefined;
    } catch {
        return false;
    }
}
